import React, { useState, useEffect } from 'react';
import Modal from "../../../../components/molecules/Modal"
import ServiceCard from "../molecules/ServiceCard";
import data from '../../constants/WooCommerceServices'

const SubscriptionModal = props => {
    let title;
    if (props.type === 'woocommerce') {
        title=`Paket WooCommerce`;
    } else {
        title=`Paket Shopify`;
    }
    const showLoading = () => {
        return (
            <div
                className="alert alert-info mb-0"
                style={{display: props.loading ? '' : 'none'}}
            >
              Sedang membuat kunci baru mohon ditunggu ya...
            </div>
        )
    };

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size={'xl'}
            title={title}
            bodyClassName="p-0"
            buttons
        >
            { showLoading() }
            <div className="row p-4">
            {
                data.map(i => (
                    <div className="col-3">
                        <ServiceCard
                            title={i.type}
                            price={i.price}
                            services={i.services}
                            onClick={props.onClick}
                        />
                    </div>
                    
                ))
            }
            </div>
        </Modal>
    )
}

export default SubscriptionModal;